import { Box, Heading } from '@chakra-ui/react';
import { useTodosQuery } from 'generated/graphql';
import TodoList from './TodoList';

function Todos() {
  const { data, loading } = useTodosQuery();

  if (loading || !data) return null;

  const todos = data.todos.edges.map(edge => edge.node!);

  return (
    <Box>
      <Heading as="h4" size="md" mb={8}>
        Your To-Do List
      </Heading>
      <TodoList todos={todos} />
    </Box>
  );
}

export default Todos;
